export enum UserGranredAuthorityName {
    MAIN = 'MAIN_MODULE_NAME',
    LOGGING_FUNDED = 'LOGGING_FUNDED',
    CUSTOMERS = "CUSTOMERS",
    LEADS = "LEADS",
    PARTNERS = "PARTNERS",
    EMPLOYEES = "EMPLOYEES",
    SCHEDULED_TASKS = "SCHEDULED_TASKS",
    CAMPAIGNS = "CAMPAIGNS",
    REDIRECTS = "REDIRECTS",
    STATISTICS = "STATISTICS",
    INSTANCE_CONFIGURATION = "INSTANCE_CONFIGURATION",
    CALCULATIONS = "CALCULATIONS",
    OPPORTUNITIES = "OPPORTUNITIES",
    USERS = "USERS",
    BRANCH = "BRANCH",
    LOGGING = "LOGGING",
    MAIL_LOGGING = "MAIL_LOGGING",
    TRANSFER_LO = "TRANSFER_LO",
    MANUAL_IMPORT = "MANUAL_IMPORT",
    TEMPORARY_DELETE_CUSTOMER = "TEMPORARY_DELETE_CUSTOMER",
    PERMANENTLY_DELETE_CUSTOMER = "PERMANENTLY_DELETE_CUSTOMER",
    CSV_EXPORT = "CSV_EXPORT",
    MORPH = "MORPH",
    AI_EMAIL_GENERATE = "AI_EMAIL_GENERATE",
    OPPORTUNITY_CUSTOMER_MAILING = "OPPORTUNITY_CUSTOMER_MAILING",
    OPPORTUNITY_PHYSICAL_MAILING = "OPPORTUNITY_PHYSICAL_MAILING",
    OPPORTUNITY_EMPLOYEE_MAILING = "OPPORTUNITY_EMPLOYEE_MAILING",
    SENDING_SMS = "SENDING_SMS",
    MFA_AUTH_REQUEST = "MFA_AUTH_REQUEST", // todo temporary, we should investigate why 40 users have this authority, and rest not
    REFRESH_ACCESS = "REFRESH_ACCESS"
}

